import "../scss/app.scss";
import {onLoading} from "./_modules/website";
import {loadPage} from "./_modules/home";
import * as Functions from './_modules/functions.js'
import $ from "jquery";


/*const InfiniteScroll = require('infinite-scroll');
const jQueryBridget = require('jquery-bridget');
const imagesLoaded = require('imagesloaded');*/


import {
    Swiper,
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    EffectCoverflow
} from 'swiper';
import 'swiper/css';

document.addEventListener("DOMContentLoaded", () => {

Swiper.use([Navigation, Pagination, Scrollbar, EffectCoverflow, Autoplay]);

const swiper = new Swiper('.swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 25,
    autoplay: {
        delay: 4000,
    },
    speed: 500,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
        el: '.swiper-scrollbar',
    },
    breakpoints: {
        // when window width is >= 320px
        920: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
    }
})


InfiniteScroll.imagesLoaded = imagesLoaded;



    onLoading();
    loadPage();


    let elem = document.querySelector('.infinite-container');

    if (elem) {

        let infScroll = new InfiniteScroll(elem, {
            // options
            path: ".pagination__next",
            append: '.infinite-post',
            history: true,
            elementScroll: elem.getAttribute('data-container'),
            loadOnScroll: elem.getAttribute('data-loadOnScroll'),
            button: '.view-more-button',
            scrollThreshold: 1000,
        });

        infScroll.on('last', function (body, path) {
            $('.view-more-button').show();
            $('.view-more-button').addClass("disable");
            $('.main').removeClass("no-overflow");
        });

        infScroll.on('append', function (body, path) {
            imagesLoaded(document.querySelector('.infinite-container'), function (instance) {
                $('.infinite-post').removeClass("hide");
            });
        });
    }



// Menu

$('.menu-item-has-children').hover(function () {

    $(this).append("<div class='menu-bar'></div>");

    $(this).addClass("open");

    /*$('.menu-bar').addClass("show");*/

    Functions.setMenuBarSize();
    $('.section-header .section-header-title, .section-header .section-header-subtitle').css("opacity", "0");


}, function () {
    $(".menu-item-has-children").removeClass("open");
    $('.menu-item-has-children').removeClass("show");
    $('.section-header .section-header-title, .section-header .section-header-subtitle').css("opacity", "1");
    $('.menu-bar').remove();
})


/*Collapse Menu*/

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {

    coll[i].addEventListener("click", function () {
        var button = this;
        this.classList.toggle("active");
        console.log(this);
        var content = this.nextElementSibling;
        var docHeight = window.innerHeight - 60;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            if (this.classList.contains("full-screen-collapsible")) {
                content.style.maxHeight = docHeight + "px";
                content.style.height = docHeight + "px";
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }

        content.addEventListener("transitionend", function () {
            if (button.classList.contains('active')) {
                button.classList.toggle("is-collapsing");
            } else {
                button.classList.remove("is-collapsing");
            }
        });
    });
}



var subcoll = document.getElementsByClassName("menu-item-has-children");
var j;

for (j = 0; j < subcoll.length; j++) {
    subcoll[j].addEventListener("click", function () {
        console.log(subcoll[j]);
        var button = this;
        this.classList.toggle("active");
        var content = this.querySelector('.sub-menu');
        console.log(content);
        var docHeight = window.innerHeight - 60;
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
        }
    });
}


window.addEventListener('resize', windowResize);

function windowResize() {
    console.log("windowresize");
    var coll = document.getElementsByClassName("full-screen-collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
        var button = coll[i];
        var content = button.nextElementSibling;
        var docHeight = window.innerHeight - 60;

        content.style.height = "";
        content.style.maxHeight = "";
        button.classList.remove("active");
        button.classList.remove("is-collapsing");
    }
}

/* Mobile sub Menu item*/

/*var subcoll = document.getElementsByClassName("menu-item-has-children");
var i;

for (i = 0; i < subcoll.length; i++) {
    var button = subcoll[i];
    subcoll[i].addEventListener("click", function () {
        alert('ok');
    });
}*/


/*Scroll on Magazine*/


var scrollableElement = document.querySelector('.scroll-container'); //document.getElementById('scrollableElement');

scrollableElement.addEventListener('wheel', checkScrollDirection);

function checkScrollDirection(event) {
    if (checkScrollDirectionIsUp(event)) {
        /*UP*/
        if (!$('.main').hasClass("no-overflow") && $('main').scrollTop !== 0) {
            $('.main').animate(
                {scrollTop: "0"}, 200);
            $('.main').addClass("no-overflow");
        }

    } else {
        /*DOWN*/
    }
}

function checkScrollDirectionIsUp(event) {
    if (event.wheelDelta) {
        return event.wheelDelta > 0;
    }
    return event.deltaY < 0;
}


});